// require('../../js/bootstrap');
require('./_functions');
// require('./_browser_comp');
require('./_resize');
// require('./404');
require('./checkout');
require('./common');
require('./contact');
require('./filters');
require('./forms');
require('./promocode');
require('./modal');
require('./navigation');
require('./product');
require('./favorites');
require('./register');
require('./login');
require('./forgot_password');
require('./starrr.js');
require('./footer.js');
require('./home.js');
